import {
    RequestError as RequestErrorBase,
    RequestErrorOptions,
    createErrorInstanceOf,
    createErrorMarker,
} from '@adv-frontend/error';

export class RequestError extends RequestErrorBase<undefined> {}

export class AbortError extends RequestError {
    constructor(options: RequestErrorOptions<undefined>) {
        super(options);
        Object.assign(this, { [createErrorMarker('AbortError')]: true });
    }

    public override readonly name = 'AbortError';
    public readonly code = 'AbortError';
}

Object.defineProperty(AbortError, Symbol.hasInstance, {
    value: createErrorInstanceOf('AbortError'),
    configurable: true,
});

export class NetworkError extends RequestError {
    constructor(options: RequestErrorOptions<undefined>) {
        super(options);
        Object.assign(this, { [createErrorMarker('NetworkError')]: true });
    }

    public override readonly name = 'NetworkError';
    public readonly code = 'NetworkError';
}

Object.defineProperty(NetworkError, Symbol.hasInstance, {
    value: createErrorInstanceOf('NetworkError'),
    configurable: true,
});

export class ReadResponseBodyError extends RequestError {
    constructor(options: RequestErrorOptions<undefined>) {
        super(options);
        Object.assign(this, { [createErrorMarker('ReadResponseBodyError')]: true });
    }

    public override readonly name = 'ReadResponseBodyError';
    public readonly code = 'ReadResponseBodyError';
}

Object.defineProperty(ReadResponseBodyError, Symbol.hasInstance, {
    value: createErrorInstanceOf('ReadResponseBodyError'),
    configurable: true,
});

export class ParsingError extends RequestError {
    constructor(options: RequestErrorOptions<undefined>) {
        super(options);
        Object.assign(this, { [createErrorMarker('ParsingError')]: true });
    }

    public override readonly name = 'ParsingError';
    public readonly code = 'ParsingError';
}

Object.defineProperty(ParsingError, Symbol.hasInstance, {
    value: createErrorInstanceOf('ParsingError'),
    configurable: true,
});

export class ServerError extends RequestError {
    constructor(options: RequestErrorOptions<undefined>) {
        super(options);
        Object.assign(this, { [createErrorMarker('ServerError')]: true });
    }
    public override readonly name = 'ServerError';
    public readonly code = 'ServerError';
}

Object.defineProperty(ServerError, Symbol.hasInstance, {
    value: createErrorInstanceOf('ServerError'),
    configurable: true,
});

export class TimeoutError extends RequestError {
    constructor(options: RequestErrorOptions<undefined>) {
        super(options);
        Object.assign(this, { [createErrorMarker('TimeoutError')]: true });
    }

    public override readonly name = 'TimeoutError';
    public readonly code = 'TimeoutError';
}

Object.defineProperty(TimeoutError, Symbol.hasInstance, {
    value: createErrorInstanceOf('TimeoutError'),
    configurable: true,
});
